var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.333 11.463v3.594c0 .198.187.36.417.36h12.5c.23 0 .417-.162.417-.36V7.899c0-.2-.187-.36-.417-.36H10c-.25 0-.487-.113-.645-.307L7.188 4.584H3.75c-.23 0-.417.16-.417.359v6.52zm12.917 5.62H3.75c-1.148 0-2.083-.909-2.083-2.026V4.943c0-1.118.935-2.026 2.083-2.026h3.834c.25 0 .487.112.645.306l2.166 2.649h5.855c1.148 0 2.083.908 2.083 2.027v7.158c0 1.117-.935 2.027-2.083 2.027z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6bb7715d6512bacccc7759da4ce2569e.svg";
export { ForwardRef as ReactComponent };